import { connect } from 'react-redux';

import {
  removeSegmentStep,
  setSegmentStepClosingRange,
  setSegmentStepCount,
  setSegmentStepEventName,
  setSegmentStepType,
} from '../../../actions/segment';
import { getEventNames } from '../../../reducers/analyticsApp';
import SegmentUpdateStep from '../../../components/segment/update/Step';

const mapStateToProps = (state, { stepIndex, firstEnabledStepIndex }) => ({
  events: getEventNames(state),
  first: !stepIndex || stepIndex === firstEnabledStepIndex,
});

const mapDispatchToProps = (dispatch, { stepIndex }) => ({
  setStepType: (stepType) => dispatch(setSegmentStepType(stepIndex, stepType)),
  setEventName: (event) => dispatch(setSegmentStepEventName(stepIndex, event)),
  setClosingRange: (closingRange) => dispatch(setSegmentStepClosingRange(stepIndex, closingRange)),
  removeStep: () => dispatch(removeSegmentStep(stepIndex)),
  setStepCount: (count, operator) => dispatch(setSegmentStepCount(stepIndex, count, operator)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SegmentUpdateStep);
